import React, { useState, useRef, useEffect, createContext } from "react";
import Icon2 from "../img/icon2.png";

export const PanelsContext = createContext();

export const PanelsState = ({ children }) => {
  const canvasRef = useRef(null);
  const imageRef = useRef(null);
  const clickRef = useRef(null);
  const textColorRef = useRef(null);
  const textBgRef = useRef(null);
  const iconBgRef = useRef(null);
  const downloadRef = useRef(null);
  const [canvasImg, setCanvasImg] = useState(Icon2);
  const [canvasBg, setCanvasBg] = useState("#111");
  const [text, setText] = useState("h3h394");
  const [textColor, setTextColor] = useState("#fff");
  const [textBackground, setTextBackground] = useState("#272C6D");
  const [textHorizontal, setTextHorizontal] = useState(10);
  const [textVertical, setTextVertical] = useState(80);
  const [iconHorizontal, setIconHorizontal] = useState(80);
  const [iconVertical, setIconVertical] = useState(80);
  const [iconBackground, setIconBackground] = useState("#9147FF");
  const [fontSize, setFontSize] = useState("14");
  const [fontWeight, setFontWeight] = useState("300");
  const [fontFamily, setFontFamily] = useState("Montserrat");
  const [openIconPicker, setOpenIconPicker] = useState(true);
  const [openTextColor, setOpenTextColor] = useState(true);
  const [openTextBg, setOpenTextBg] = useState(true);
  const [openIconBg, setOpenIconBg] = useState(true);
  const [imgSize, setImgSize] = useState(20);
  const [removeImg, setRemoveImg] = useState(false);
  const [activeLink, setActiveLink] = useState("first");
  const [activeBg, setActiveBg] = useState("bgOne");
  const [panelHeight, setPanelHeight] = useState(80);
  const [downloadedImg, setDownloadedImg] = useState(null);

  const canvasOptions = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = 320;
    canvas.height = 80;
    canvas.height = panelHeight;
    const leftRectWidth = canvas.width * 0.25;
    const rightRectWidth = canvas.width * 0.75;

    ctx.beginPath();
    ctx.fillStyle = iconBackground;
    ctx.fillRect(0, 0, leftRectWidth, canvas.height);
    ctx.closePath();

    ctx.beginPath();
    if (!removeImg) {
      ctx.drawImage(
        imageRef.current,
        iconHorizontal / 2 - imgSize / 2,
        iconVertical / 2 - imgSize / 2,
        imgSize,
        imgSize
      );
    }
    ctx.closePath();

    ctx.beginPath();
    ctx.fillStyle = textBackground;
    ctx.fillRect(
      leftRectWidth,
      canvas.height / 2 - canvas.height / 2,
      rightRectWidth,
      canvas.height
    );
    ctx.font =
      fontWeight + " " + fontSize + "px" + " " + fontFamily + ",sans-serif";
    ctx.fillStyle = textColor;
    ctx.textBaseline = "middle";
    ctx.fillText(text, leftRectWidth + textHorizontal, textVertical / 2);
    ctx.closePath();

    let dataURL = canvas.toDataURL("image/png");
    downloadRef.current.href = dataURL;
    setDownloadedImg(dataURL);
  };

  useEffect(() => {
    setTextVertical(panelHeight);
    setIconVertical(panelHeight);
  }, [panelHeight]);

  const handleShowImg = () => {
    setRemoveImg(!removeImg);
  };

  const handleActive = (btnType) => setActiveLink(btnType);
  const handleBackground = (btnActive) => setActiveBg(btnActive);

  useEffect(() => {
    canvasOptions();
  }, [
    text,
    fontFamily,
    fontWeight,
    fontSize,
    imgSize,
    removeImg,
    textColor,
    textBackground,
    iconBackground,
    panelHeight,
    textHorizontal,
    textVertical,
    iconHorizontal,
    iconVertical,
    canvasBg,
    canvasImg,
    downloadedImg,
    removeImg,
  ]);

  return (
    <PanelsContext.Provider
      value={{
        canvasRef,
        imageRef,
        canvasImg,
        setCanvasImg,
        text,
        setText,
        canvasOptions,
        fontSize,
        setFontSize,
        fontWeight,
        setFontWeight,
        fontFamily,
        setFontFamily,
        openIconPicker,
        setOpenIconPicker,
        clickRef,
        imgSize,
        setImgSize,
        removeImg,
        setRemoveImg,
        handleShowImg,
        handleActive,
        activeLink,
        setActiveLink,
        textColor,
        setTextColor,
        textColorRef,
        openTextColor,
        setOpenTextColor,
        textBackground,
        setTextBackground,
        textBgRef,
        openTextBg,
        setOpenTextBg,
        iconBackground,
        setIconBackground,
        iconBgRef,
        openIconBg,
        setOpenIconBg,
        panelHeight,
        setPanelHeight,
        textHorizontal,
        setTextHorizontal,
        textVertical,
        setTextVertical,
        iconHorizontal,
        setIconHorizontal,
        iconVertical,
        setIconVertical,
        canvasBg,
        setCanvasBg,
        activeBg,
        setActiveBg,
        handleBackground,
        downloadedImg,
        downloadRef,
      }}
    >
      {children}
    </PanelsContext.Provider>
  );
};
